import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';



const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Food Blogger",
    avatar: "https://images.unsplash.com/photo-1618636533948-bb301ef06b31",
    avatarAlt: "Professional headshot of smiling woman with brown hair in casual blue shirt",
    rating: 5,
    text: "Absolutely incredible! The flavors are authentic and the presentation is beautiful. Pesto has become my go-to restaurant for special occasions and casual dining alike.",
    date: "2 days ago"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "Local Resident",
    avatar: "https://images.unsplash.com/photo-1724128195747-dd25cba7860f",
    avatarAlt: "Professional headshot of Hispanic man with short black hair in navy suit smiling at camera",
    rating: 5,
    text: "The best burger I've ever had! The ingredients are fresh, the service is fast, and the atmosphere is perfect for families. Highly recommend the weekend specials!",
    date: "1 week ago"
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "Business Owner",
    avatar: "https://images.unsplash.com/photo-1684262855358-88f296a2cfc2",
    avatarAlt: "Professional headshot of Asian woman with long black hair in white blazer smiling confidently",
    rating: 5,
    text: "Outstanding quality and service! I order from Pesto for all my business meetings. The food always arrives on time and exceeds expectations. Five stars!",
    date: "3 days ago"
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Chef",
    avatar: "https://images.unsplash.com/photo-1607845046636-dca2447c0dee",
    avatarAlt: "Professional headshot of middle-aged man with beard wearing chef\'s coat in kitchen setting",
    rating: 5,
    text: "As a fellow chef, I appreciate the attention to detail and quality ingredients. The pasta dishes are exceptional and remind me of authentic Italian cuisine.",
    date: "5 days ago"
  }];


  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) =>
    <Icon
      key={index}
      name="Star"
      size={16}
      className={index < rating ? "text-accent fill-current" : "text-muted-foreground"} />

    );
  };

  return;
































































































































};

export default TestimonialsSection;